
import { MetaTags } from "@/components/seo/MetaTags";
import { StructuredData } from "@/components/seo/StructuredData";
import { MainContent } from "@/components/index/MainContent";
import { seoConfig } from "@/components/seo/config";

const Index = () => {
  console.log("Index page rendering");
  
  const title = "Guide Local de l'Aisne : Laon, Soissons, Saint-Quentin | NLocale";
  const description = "Découvrez les meilleures adresses de l'Aisne ! Restaurants, hébergements et activités authentiques à Laon, Soissons et Saint-Quentin. Votre guide local pour des expériences uniques.";
  const canonicalUrl = seoConfig.baseUrl;
  const imageUrl = seoConfig.defaultImage;

  return (
    <>
      <MetaTags
        title={title}
        description={description}
        canonicalUrl={canonicalUrl}
        imageUrl={imageUrl}
      />
      <StructuredData 
        description={description}
        canonicalUrl={canonicalUrl}
      />
      
      <main className="bg-gradient-to-b from-white to-gray-50 min-h-screen flex flex-col">
        <MainContent />
      </main>
    </>
  );
};

export default Index;
